import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';

import ResponseError from '../../models/ResponseError';
import styles from './tapa.module.css';
import TapaOrdersComponent from './TapaOrdersComponent';
import TapaCompletedInspectionList from './TapaCompletedInspectionList';
import TapaInspectionFormComponent from './TapaInspectionComponent';
import TapaHeaderComponent from './TapaHeaderComponent';
import LinkOrderComponent from './LinkOrderComponent';
import tapaRemote from '../../api/tapaRemote';
import OrderDashboard from '../../models/OrderDashboard';
import ApiResponse from '../../models/ApiResponse';
import moment, { Moment } from 'moment';
import { TAPA_SCHEMA } from '../../utils/tapaForm';
import TapaModel from '../../models/TapaForm';
import User from '../../models/User';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import TapaLinkModal from './TapaLinkModal';
import { baseUrl } from '../../api/baseUrl';

interface TAPAContainerProps {
  user: User;
  receiveError: (error: ResponseError) => void;
};

interface TAPAContainerState {
  unlinkedOrders: Array<OrderDashboard>;
  openInspectionForm: boolean;
  inspectionDate: Moment;
  ordersDate: Moment;
  linkOrderModal: boolean;
  selectedOrder: OrderDashboard;
  tapaForms: Array<any>;
  selectedForm: TapaModel;
  tapaSingleForm: TapaModel;
  selectedTapaId: number;
  type: string;
  selectedOrderDetails: any;
  deleteConfirmation: boolean;
  unlinkConfirmation: boolean;
  orderNumber: string;
  linkedOrdersModal: boolean;
  errors: TapaModel;
  progress: boolean;
};

class TAPAContainer extends Component<TAPAContainerProps, TAPAContainerState> {
  state: TAPAContainerState = {
    unlinkedOrders: [],
    openInspectionForm: false,
    inspectionDate: moment(),
    ordersDate: moment(),
    linkOrderModal: false,
    selectedOrder: {} as OrderDashboard,
    tapaForms: [],
    selectedForm: TAPA_SCHEMA,
    tapaSingleForm: TAPA_SCHEMA,
    selectedTapaId: -1,
    type: 'create',
    selectedOrderDetails: {},
    deleteConfirmation: false,
    unlinkConfirmation: false,
    orderNumber: '',
    linkedOrdersModal: false,
    errors: TAPA_SCHEMA,
    progress: false
  };

  componentDidMount() {
    this.getTapaForms();
    this.getUnlinkedOrders();
  }

  openCloseModal = (type: string, id?: number) => {
    switch (type) {
      case 'link':
        const form = this.state.tapaForms.filter((item: any) => item.id == id);
        this.setState({ selectedForm: form[0] }, () => {
          this.setState({ linkOrderModal: !this.state.linkOrderModal, });
        });
        break;
      case 'linkclose':
        this.setState({ linkOrderModal: !this.state.linkOrderModal, tapaSingleForm: TAPA_SCHEMA, selectedForm: TAPA_SCHEMA  });
        break;
      case 'createform':
        this.setState({ openInspectionForm: true, type: 'create' });
        break;
      case 'vieworders':
        if(id) {
          const form2 = this.state.tapaForms.filter((item: any) => item.id == id);
          this.setState({ selectedForm: form2[0], selectedTapaId: id }, () => {
            this.setState({ linkedOrdersModal: true });
          });
        }
        break;
      case 'linkorder':
        const tapaSingleForm = { ...this.state.tapaSingleForm };
        tapaSingleForm.driver_name = this.state.selectedOrder.driver_name;
        tapaSingleForm.tractor_license = this.state.selectedOrder.driver_vehichle_registration;
        tapaSingleForm.carrier = this.state.selectedOrder.delivery_company_name;
        tapaSingleForm.id_order = this.state.selectedOrder.id;
        this.setState({ openInspectionForm: !this.state.openInspectionForm, tapaSingleForm });
        break;
    
      default:
        this.setState({ openInspectionForm: !this.state.openInspectionForm });
        break;
    }
    this.getTapaForms();
    this.getUnlinkedOrders();
  };

  closeModal = (type: string): void => {
    if(type === 'form') {
      this.setState({ openInspectionForm: false, tapaSingleForm: TAPA_SCHEMA, selectedForm: TAPA_SCHEMA });
    } else if(type === 'vieworders') {
      this.setState({ linkedOrdersModal: false });
    }
  }

  isValid = (): boolean => {

    const errors: any = { ...this.state.errors };
    const tapaData: TapaModel = { ... this.state.tapaSingleForm };
    let hasError: boolean = false;

    Object.entries(tapaData).forEach(([key, value]) => {

      if (value === '' && key === 'truck_number') {
        errors[key] = 'Add';
        hasError = true;
      } else {
        errors[key] = '';
      }

      if (value === '' && key === 'origin') {
        errors[key] = 'Add';
        hasError = true;
      } else {
        errors[key] = '';
      }

    });

    this.setState({ errors });
    return hasError;
  }

  changeDate = (type: string, date: any): void => {
   const tapaSingleForm = { ...this.state.tapaSingleForm };
    if (type === 'orders') {
      this.setState({ ordersDate: date }, () => {
        this.getUnlinkedOrders();
      });
    } else if(type === 'follow_up_time') {
      tapaSingleForm.follow_up_time = moment(date).format("HH:mm");
      this.setState({ tapaSingleForm });
    } else if(type === 'follow_up_date') {
      tapaSingleForm.follow_up_date = moment(date).format("YYYYMMDD");
      this.setState({ tapaSingleForm });
    }  else {
      this.setState({ inspectionDate: date }, () => {
        this.getTapaForms();
      });
    }
  };
  
  submitForm = (): void => {
    if(this.state.type === 'edit') {
      this.updateFormFields(this.state.selectedTapaId);
    } else {
      this.createTapaForm();
    }
  }

  createTapaForm = (): void => {
    this.setState({ progress: true }, () => {
      tapaRemote.addUpdateTapa(this.state.tapaSingleForm).then((resp: ApiResponse<TapaModel>) => {
        const pos: TapaModel | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (pos) {
          this.getUnlinkedOrders();
          this.getTapaForms();
          this.setState({ openInspectionForm: !this.state.openInspectionForm, selectedOrder: {} as OrderDashboard, tapaSingleForm: TAPA_SCHEMA, selectedForm: TAPA_SCHEMA, progress: false  });
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    });
  }

  updateFormFields = (id: number): void => {
    this.setState({ progress: true }, () => {
      tapaRemote.addUpdateTapa(this.state.tapaSingleForm, id).then((resp: ApiResponse<TapaModel>) => {
        const pos: TapaModel | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (pos) {
          this.getUnlinkedOrders();
          this.getTapaForms();
          this.setState({ openInspectionForm: !this.state.openInspectionForm, selectedOrder: {} as OrderDashboard, progress: false });
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    });
  }

  updateTapaFormChecks = (checks: string): void => {
    this.setState({ progress: true }, () => {
      tapaRemote.addUpdateTapa(this.state.tapaSingleForm, this.state.selectedTapaId, checks).then((resp: ApiResponse<TapaModel>) => {
        const pos: TapaModel | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (pos) {
         this.setState({ tapaSingleForm: pos, progress: false });
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    });
  }

  editForm = (id: number): void => {
    tapaRemote.getSingleFormDetails(id).then((resp: ApiResponse<TapaModel>) => {
      const pos: TapaModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      if (pos) {
       this.setState({ tapaSingleForm: pos, openInspectionForm: true, type: 'edit', selectedTapaId: id });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  submitLink = (type: string, orderNumber: string, tapaId?: number): void => {
    if(type === 'link') {
      this.openCloseModal('linkclose');
      tapaRemote.linkUnlinkTapa(type, orderNumber, tapaId).then((resp: ApiResponse<boolean>) => {
        const pos: boolean | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (pos) {
          this.getUnlinkedOrders();
          this.getTapaForms();
          this.setState({ selectedOrder: {} as OrderDashboard });
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    } else {
      tapaRemote.linkUnlinkTapa(type, orderNumber, tapaId).then((resp: ApiResponse<boolean>) => {
        const pos: boolean | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (pos) {
          this.getUnlinkedOrders();
          this.getTapaForms();
          const form2 = this.state.tapaForms.filter((item: any) => item.id == this.state.selectedTapaId);
          this.setState({ selectedForm: form2[0] }, () => {
            this.setState({ linkedOrdersModal: false });
          });
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
   
  }

  unlinkTapa = (): void => {
    this.submitLink('unlink', this.state.orderNumber, this.state.selectedTapaId);
   
    this.setState({ unlinkConfirmation: false,  });
  }

  print = (id: number): void => {
    let url: string = `${baseUrl}tapa/file/${id}`;

    window.open(url);
  }

  getUnlinkedOrders = (): void => {
    let startDate: string = this.state.ordersDate.format('YYYYMMDD');
    tapaRemote.getUnlinkedPickupOrders('tapa', startDate).then((resp: ApiResponse<Array<OrderDashboard>>) => {
      const pos: Array<OrderDashboard> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ unlinkedOrders: pos });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  deleteForm = (): void => {
    tapaRemote.deleteTapa(this.state.selectedTapaId, this.state.orderNumber).then((resp: ApiResponse<number>) => {
      const pos: number | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ deleteConfirmation: false, selectedTapaId: -1, orderNumber: '' });
        this.getTapaForms();
        this.getUnlinkedOrders();
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  onBlur = (field: string): void => {
    if(this.state.type === 'edit') {
      this.updateTapaFormChecks(field);
    }
  }

  openConfirmation = (type: string, tapaId: number, orderNumber: string): void => {
    if(type === 'delete') {
      this.setState({ deleteConfirmation: true, selectedTapaId: tapaId, orderNumber: orderNumber });
    } else {
      this.setState({ unlinkConfirmation: true, selectedTapaId: tapaId, orderNumber: orderNumber });
    }
  }

  getTapaForms = (): void => {
    let startDate: string = this.state.inspectionDate.format('YYYYMMDD');
    tapaRemote.getTapaForms(startDate).then((resp: ApiResponse<Array<TapaModel>>) => {
      const pos: Array<TapaModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ tapaForms: pos });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  };

  handleChange = (type: string, event: any): void => {
    if (type === 'order') {
      const order = this.state.unlinkedOrders.filter((order: OrderDashboard) => order.id == event.target.value);
      this.setState({ selectedOrder: order[0] });
    }
  };

  handleFormChange = (field: string, event: any): void => {
    const day = new Date;
    const form = { ...this.state.tapaSingleForm };
    switch (field) {
      case 'truck_number':
        form.truck_number = event.target.value;
        break;
      case 'origin':
        form.origin = event.target.value;
        break;
      case 'carrier':
        form.carrier = event.target.value;
        break;
      case 'driver_name':
        form.driver_name = event.target.value;
        break;
      case 'tractor_license':
        form.tractor_license = event.target.value;
        break;
      case 'trailer_license':
        form.trailer_license = event.target.value;
        break;
      case 'trailer_number':
        form.trailer_number = event.target.value;
        break;
      case 'follow_up_name':
        form.follow_up_name = event.target.value;
        break;
      case 'seal_arrival':
        form.seal_arrival = event.target.value;
        form.seal_arrival_checked_user = this.props.user.firstName;
        form.user_arrival_seal_date = day.toString();
        break;
      case 'seal_departure':
        form.seal_departure = event.target.value;
        form.seal_departure_checked_user = this.props.user.firstName;
        form.user_departure_seal_date = day.toString();
        break;
      case 'remarks':
        form.remarks = event.target.value;
        break;

      default:
        break;
    }
    this.setState({ tapaSingleForm: form })
  }

  handleChecksChange = (field: string, event: any): void => {
    const form = { ...this.state.tapaSingleForm };
    const day = new Date;
    switch (field) {
      case 'inspection_completed':
        form.inspection_completed = !form.inspection_completed;
        form.inspection_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.inspection_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'seal_checked':
        form.seal_checked = !form.seal_checked;
        form.seal_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.seal_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'undercarriage_check':
        form.undercarriage_check = !form.undercarriage_check;
        form.undercarriage_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.undercarriage_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'inside_doors_check':
        form.inside_doors_check = !form.inside_doors_check;
        form.inside_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.inside_doors_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'right_side_check':
        form.right_side_check = !form.right_side_check;
        form.rightside_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.right_side_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'left_side_check':
        form.left_side_check = !form.left_side_check;
        form.leftside_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.left_side_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'front_wall_check':
        form.front_wall_check = !form.front_wall_check;
        form.frontwall_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.front_wall_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'roof_check':
        form.roof_check = !form.roof_check;
        form.roof_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.roof_check_date = this.state.type === 'create' ? day.toString() : '';
        break;
      case 'floor_check':
        form.floor_check = !form.floor_check;
        form.floor_checked_user = this.state.type === 'create' ? this.props.user.firstName + ' ' + this.props.user.lastName : '';
        form.floor_check_date = this.state.type === 'create' ? day.toString() : '';
        break;

      default:
        break;
    }
    this.setState({ tapaSingleForm: form }, () => {
      if(this.state.type === 'edit') {
        this.updateTapaFormChecks(field);
      }
    })
  }

  render() {
    return (
      <div className={ styles.mainContainer }>
        <div
          className={ [styles.flex, styles.alignTop, styles.flexCol].join(' ') }>
          <TapaOrdersComponent
            date={ this.state.ordersDate }
            dateChange={ this.changeDate }
            unlinkedOrders={ this.state.unlinkedOrders }
            handleChange={ this.handleChange }
            selectedOrder={ this.state.selectedOrder }
          />
          <div className={ styles.methodCol }>
            { !this.state.openInspectionForm && (
              <TapaHeaderComponent
                date={ this.state.inspectionDate }
                dateChange={ this.changeDate }
                openForm={ this.openCloseModal }
                selectedOrder={ this.state.selectedOrder }
              />
            ) }
            { !this.state.openInspectionForm && (
              <TapaCompletedInspectionList 
                openForm={ this.openCloseModal } 
                tapaForms={ this.state.tapaForms }
                selectedOrder={ this.state.selectedOrder }
                editForm={ this.editForm }
                handleSubmit={ this.submitLink }
                openConfirmation={ this.openConfirmation }
                print={ this.print }
              />
            ) }
            { this.state.openInspectionForm && (
              <TapaInspectionFormComponent 
                openForm={ this.openCloseModal }
                errors={ this.state.errors }
                tapaForm={ this.state.tapaSingleForm }
                handleFormChange={ this.handleFormChange } 
                submit={ this.submitForm }
                handleChecksChange={ this.handleChecksChange }
                type={ this.state.type }
                onBlur={ this.onBlur }
                closeModal={ this.closeModal }
                print={ this.print }
                progressBar={ this.state.progress }
                handleDateChange={ this.changeDate }
              />
            ) }
            <LinkOrderComponent
              modalOpen={ this.state.linkOrderModal }
              handleClose={ this.openCloseModal }
              unlinkedOrder={ this.state.selectedOrder }
              tapaForm={ this.state.selectedForm }
              handleSubmit={ this.submitLink }
            />
             <TapaLinkModal
              modalOpen={ this.state.linkedOrdersModal }
              handleClose={ this.closeModal }
              tapaForm={ this.state.selectedForm }
              openConfirmation={ this.openConfirmation }
            />
            { this.state.deleteConfirmation && 
              <ConfirmationDialog
                open={ this.state.deleteConfirmation }
                close={ () => { this.setState({ deleteConfirmation: false }) } }
                title='Delete Confirmation'
                text='Are you sure you want to delete this form?'
                textConfirm='delete'
                confirm={ this.deleteForm } 
                showCloseIcon={ true }
              />
            }
            { this.state.unlinkConfirmation && 
              <ConfirmationDialog
                open={ this.state.unlinkConfirmation }
                close={ () => { this.setState({ unlinkConfirmation: false }) } }
                title='Unlink Confirmation'
                text='Are you sure you want to unlink this form to the order?'
                textConfirm='Unlink'
                confirm={ this.unlinkTapa } 
                showCloseIcon={ true }
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TAPAContainer);
